export default
{
  hi: ['Olá', 'Hi', 'Ola'],
  settings: ['Configurações', 'Settings', 'Ajustes'],
  changePass: ['Alterar Senha', 'Change Password', 'Cambiar contraseña'],
  newPass: ['Nova senha', 'New password', 'Nueva contraseña'],
  repeatNewPass: ['Repita a nova senha', 'Repeat the new password', 'Repita la nueva contraseña'],
  update: ['Atualizar', 'Update', 'Actualizar']
}
